// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hTv2t","title":"Header_title__Jyg8F","filename":"Header_filename__ECwPA"};